import {AFD} from 'devegram-javascript-util'

const baseUrl = '/xapi/Voip/TestingNumbers';
const moduleAjaxService = 'backend-service'
const api = {
    namespaced: true,
    state: {},
    actions: {
        async getNumbersFromDatabase(context, params) {
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/getNumbersFromDatabase?rate_id=' + params.rate_id + '&limit=' + params.limit,
                data: AFD(params.data)
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        async getGeneratedNumbers(context, params) {
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/getGeneratedNumbers?rate_id=' + params.rate_id + '&limit=' + params.limit + '&number_length=' + params.number_length,
                data: AFD(params.data)
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        async importTestingNumbersDocument(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/importTestingNumbersDocument',
                data: AFD(params.data)
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        async create(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/store',
                data: AFD(params.data)
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        async update(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/update/' + params.id,
                data: AFD(params.data),
                noLoadingScreen: true
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async remove(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/remove/?id=' + params.id
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async get(context, params) {
            let page = (params.page)? params.page : 1
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/get/' + params.id + '?page=' + page
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    context.dispatch('[@module-name@]-state/setOpenedEntity', r.data, {root: true}).then(() => {
                        resolve(r);
                    })
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async list (context, params) {
            let page = (params.page)? params.page : 1
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/list?page=' + page,
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, { root: true }).then(r => {
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async getDropDownList (context, params = {}) {
        	let query = ''
            if (params.hasOwnProperty('valueKey')) {
                query = '?value_key=' + params.valueKey
            }
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/dropDownList' + query,
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, { root: true }).then(r => {
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        }
    }

};

export default api
